
import { Row, Col, Empty, Button, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Loading from '../../../shared/components/Loading/Index';
import './styles.css'

export default function Items(props) {
    return (
        <Loading visible={props.loading} text='Un momento por favor.'>
            <Row style={{ minHeight: '200px', margin: '10px -10px 0px -10px' }}>
                {
                    props.items.length === 0 ?
                        <div className='vertical-center horizontal-center'>
                            <Empty description='No se encontraron datos' />
                        </div> :
                        props.items.map(item => (
                            <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} key={item.id} >
                                <div
                                    className={`content-card class${item.sectionId}`}
                                    id={`${item.id}|${item.sectionId}`}
                                    draggable={true}
                                    onDragOver={(ev) => ev.preventDefault()}
                                    onDragStart={props.onDragStart}
                                    onDragEnter={props.onDragEnter}
                                    onDragLeave={props.onDragLeave}
                                    onDrop={props.onDrop}
                                    onDragEnd={props.onDragEnd}
                                >
                                    <div className='catalog-card-content'>
                                        <div className='catalog-card-item' style={{ pointerEvents: 'none' }}>
                                            <div className="vertical-center h-100">
                                                <img src={item.imageUrl} alt="card" />
                                            </div>
                                        </div>
                                        <div className='catalog-card-info'>
                                            <div className="flex-parent">
                                                <div className="flex-child long-and-truncated">
                                                    <div className='ml-5'>
                                                        {
                                                            [undefined, '', null].includes(item.title) ?
                                                                <div style={{ color: '#d4d4d4' }}>Sin título</div> :
                                                                <div className='catalog-card-title'>{item.title}</div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="flex-child short-and-fixed">
                                                    <Tooltip title='Eliminar'>
                                                        <Button danger
                                                            type="text"
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => props.onDelete(item)}
                                                        />
                                                    </Tooltip>
                                                    <Tooltip title='Modificar'>
                                                        <Button
                                                            type="text"
                                                            onClick={() => props.onEdit(item)}
                                                            icon={<EditOutlined />}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                }
            </Row>
        </Loading>
    );
};
